'use client';

import { motion, useReducedMotion } from 'framer-motion';
import { useScrollReveal } from '@/app/hooks/use-scroll-reveal';
import { VideoPlayer } from '@/app/components/ui/video-player';

export function BrandVideo() {
  const { ref, isVisible } = useScrollReveal();
  const prefersReducedMotion = useReducedMotion();

  const fadeUp = (delay: number, y = 16) => ({
    initial: { opacity: 0, y: prefersReducedMotion ? 0 : y },
    animate: isVisible ? { opacity: 1, y: 0 } : { opacity: 0 },
    transition: {
      duration: prefersReducedMotion ? 0.15 : 0.6,
      delay: delay / 1000,
      ease: [0.22, 1, 0.36, 1] as [number, number, number, number],
    },
  });

  return (
    <section className="bg-white py-[clamp(80px,10vw,140px)]">
      <div
        ref={ref}
        className="mx-auto max-w-[1080px] px-5 md:px-10 lg:px-0"
      >
        <div className="mb-10 max-w-[720px] md:mb-14">
          <motion.div {...fadeUp(0, 12)} className="flex items-center gap-3">
            <span className="h-px w-6 bg-sandron-ink-300" aria-hidden="true" />
            <span className="font-body text-xs font-semibold uppercase tracking-[0.12em] text-sandron-ink-500">
              Our story
            </span>
          </motion.div>
          <motion.h2
            {...fadeUp(90, 20)}
            className="mt-4 font-display text-[clamp(28px,3.5vw,44px)] font-bold leading-[1.12] tracking-[-0.02em] text-sandron-ink-900 [text-wrap:balance]"
          >
            A studio that builds it, runs it, and keeps improving it.
          </motion.h2>
          <motion.p
            {...fadeUp(180, 16)}
            className="mt-4 max-w-[640px] text-lg leading-[1.55] text-sandron-ink-700"
          >
            Meet Sandron — the team behind SpaceNest. Fifty seconds on who we
            are and how we work.
          </motion.p>
        </div>

        <motion.div {...fadeUp(280, 24)}>
          <VideoPlayer
            src="/videos/sandron-brand.mp4"
            title="Sandron Infotech — studio brand reel"
            caption="50-second introduction to Sandron Infotech."
          />
        </motion.div>
      </div>
    </section>
  );
}
